module.exports = __webpack_public_path__ + "img/floor3.7d6ab4f7.jpg";